<template>
  <RevCard class="p-24">
    <h2 class="heading-2 mb-8">{{ i18n(translations.title) }}</h2>
    <p class="body-1 mb-16">
      {{ i18n(translations.subtitle) }}
    </p>

    <div class="body-1-bold mb-8 flex flex-row items-center">
      <IconCheckSmall class="mr-8" />{{ i18n(translations.automatic) }}
    </div>
    <div class="body-1-bold mb-8 flex flex-row items-center">
      <IconCheckSmall class="mr-8" />{{ i18n(translations.grow) }}
    </div>
    <div class="body-1-bold mb-32 flex flex-row items-center">
      <IconCheckSmall class="mr-8" />{{ i18n(translations.negociated) }}
    </div>

    <RevButton :to="WHAT_IS_BACKSHIP_LINK" variant="secondary">
      {{ i18n(translations.tellMeMore) }}
    </RevButton>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { IconCheckSmall } from '@ds/icons/IconCheckSmall'

import { getExternalLinkList } from '~/constants/externalLinks'

import translations from './BlockBackship.translations'

const i18n = useI18n()
const { WHAT_IS_BACKSHIP_LINK } = getExternalLinkList(i18n.currentLocale)
</script>
